import { render } from "./TwikooComment.vue?vue&type=template&id=47defe1a"
import script from "./TwikooComment.vue?vue&type=script&lang=js"
export * from "./TwikooComment.vue?vue&type=script&lang=js"

import "./TwikooComment.vue?vue&type=style&index=0&id=47defe1a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__